"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsStore = exports.QuerySearchTypes = exports.QuerySortTypeValues = exports.QuerySortTypes = void 0;
var config_1 = __importDefault(require("config"));
var Store_1 = require("./Store");
var mobx_1 = require("mobx");
var QueriesStore_1 = require("./QueriesStore");
var QuerySortTypes;
(function (QuerySortTypes) {
    QuerySortTypes["DEFAULT"] = "Default Sort Order";
    QuerySortTypes["ACCOUNT_NUMBER_ASC"] = "Account Number Ascending";
    QuerySortTypes["ACCOUNT_NUMBER_DESC"] = "Account Number Descending";
    QuerySortTypes["CUSTOMER_NAME_A_Z"] = "Customer Name A-Z";
    QuerySortTypes["CUSTOMER_NAME_Z_A"] = "Customer Name Z-A";
    QuerySortTypes["DUE_DATE_ASC"] = "Due Date Ascending";
    QuerySortTypes["DUE_DATE_DESC"] = "Due Date Descending";
    QuerySortTypes["INVOICE_VALUE_ASC"] = "Total Invoice Value Ascending";
    QuerySortTypes["INVOICE_VALUE_DESC"] = "Total Invoice Value Descending";
    QuerySortTypes["STAGE_ASC"] = "Current Stage Ascending";
    QuerySortTypes["STAGE_DESC"] = "Current Stage Descending";
})(QuerySortTypes = exports.QuerySortTypes || (exports.QuerySortTypes = {}));
var QuerySortTypeValues;
(function (QuerySortTypeValues) {
    QuerySortTypeValues["DEFAULT"] = "-id";
    QuerySortTypeValues["ACCOUNT_NUMBER_ASC"] = "acNumber";
    QuerySortTypeValues["ACCOUNT_NUMBER_DESC"] = "-acNumber";
    QuerySortTypeValues["CUSTOMER_NAME_A_Z"] = "customer";
    QuerySortTypeValues["CUSTOMER_NAME_Z_A"] = "-customer";
    QuerySortTypeValues["DUE_DATE_ASC"] = "dueDate";
    QuerySortTypeValues["DUE_DATE_DESC"] = "-dueDate";
    QuerySortTypeValues["INVOICE_VALUE_ASC"] = "totalInvoiceValue";
    QuerySortTypeValues["INVOICE_VALUE_DESC"] = "-totalInvoiceValue";
    QuerySortTypeValues["STAGE_ASC"] = "currentStage";
    QuerySortTypeValues["STAGE_DESC"] = "-currentStage";
})(QuerySortTypeValues = exports.QuerySortTypeValues || (exports.QuerySortTypeValues = {}));
var QuerySearchTypes;
(function (QuerySearchTypes) {
    QuerySearchTypes["ACCOUNT_NUMBER"] = "acNumber";
    QuerySearchTypes["CUSTOMER"] = "customer";
    QuerySearchTypes["DUE_DATE"] = "dueDate";
    QuerySearchTypes["INVOICE_NUMBER"] = "invoiceNumber";
    QuerySearchTypes["LOG_NUMBER"] = "logNumber";
    QuerySearchTypes["CREDIT_DEBIT_NUMBER"] = "creditDebitNumber";
})(QuerySearchTypes = exports.QuerySearchTypes || (exports.QuerySearchTypes = {}));
var storage_keys = config_1.default.storage_keys;
var PrefsStore = /** @class */ (function (_super) {
    __extends(PrefsStore, _super);
    function PrefsStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            if (localStorage.getItem(storage_keys.PREFS) == null)
                localStorage.setItem(storage_keys.PREFS, JSON.stringify(data));
            _this.data = data;
        };
        _this.unsetData = function () {
            localStorage.removeItem(storage_keys.PREFS);
            _this.data = null;
        };
        _this.editData = function (data) {
            _this.data = __assign(__assign({}, _this.data), data);
            localStorage.setItem(storage_keys.PREFS, JSON.stringify(mobx_1.toJS(_this.data)));
        };
        return _this;
    }
    return PrefsStore;
}(Store_1.Store));
exports.PrefsStore = PrefsStore;
var prefData = localStorage.getItem(storage_keys.PREFS);
var initialTable = {
    perPage: 100,
    page: 1,
    results: 0,
    totalPages: 1,
    search: '',
    sort: '-id'
};
var initData = {
    queryPrefs: {
        currentUserOnly: true,
        currentQueryType: "All Query Types",
        currentCountry: "All Countries",
        searchType: QuerySearchTypes.ACCOUNT_NUMBER,
        searchValue: "",
        activeTab: QueriesStore_1.QueryStatus.ACTIVE,
        sortType: QuerySortTypes.DEFAULT,
        sortTypeValue: QuerySortTypeValues.DEFAULT
    },
    queryTable: initialTable
};
var prefsStore = new PrefsStore(prefData !== null && JSON.parse(prefData) || initData);
exports.default = prefsStore;
